import { Property } from "./interfaces";

export const cantidadMedicamento: Property = {
    title: "Cantidad de Medicamento",
    type: "integer"
}